// extracted by mini-css-extract-plugin
export default {"searchByBarcode":"searchByBarcode-e2fYN","routineList":"routineList-ZE8Xn","controls":"controls-ktOnf","option":"option-n9qEa","bigMessage":"bigMessage-E_J_S"};